import { useContext } from "react";
import InputSetupWizardContext from "components/inputs/InputSetupWizard/contexts/InputSetupWizardContext";
const useInputSetupWizard = () => {
  const inputSetupWizard = useContext(InputSetupWizardContext);
  if (!inputSetupWizard) {
    throw new Error("useInputSetupWizard hook needs to be used inside InputSetupWizardContext.Provider");
  }
  return inputSetupWizard;
};
export default useInputSetupWizard;
